<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title> {{data.nombreCompleto | titlecase}}</h2>
<br>
<mat-dialog-content *appRoles="['Personas.Ver']">
  <div class="property-row">
    <span class="property-name">Estado:</span>
    <span class="property-value"> <app-status-badge [estado]="data.activo"></app-status-badge></span>
  </div>
  <div class="property-row">
    <span class="property-name">Nombre:</span>
    <span class="property-value"> {{data?.nombre}} </span>
  </div>
  <div class="property-row">
    <span class="property-name">Apellido:</span>
    <span class="property-value"> {{data?.apellido}}</span>
  </div>

  <div class="property-row">
    <span class="property-name">Tipo Documento:</span>
    <span class="property-value"> {{data?.tipoDocumento?.descripcion}} </span>
  </div>
  <div class="property-row">
    <span class="property-name">Nro. Documento:</span>
    <span class="property-value"> {{data?.nroDocumento}} </span>
  </div>
  <div class="property-row">
    <span class="property-name">Correo:</span>
    <span class="property-value"> {{data?.correo}} </span>
  </div>
  <div class="property-row">
    <span class="property-name">Telefono Principal:</span>
    <span class="property-value"> {{data?.telefonoPrincipal}}</span>
  </div>


  <mat-divider></mat-divider>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Enviar comentario</mat-card-title>
      <mat-card-subtitle>Sección para enviar un correo o WhatsApp</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="personaForm">
        <!-- Fila para Correo -->
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-input">
            <mat-label>Correo electrónico</mat-label>
            <input matInput type="email" formControlName="CorreoElectronico" placeholder="Ingrese el correo electrónico">
            <mat-error *ngIf="personaForm.controls['CorreoElectronico'].hasError('required')">
              Este campo es <strong>requerido</strong>.
            </mat-error>
          </mat-form-field>

          <button mat-raised-button color="accent" class="form-button" [disabled]="!personaForm.valid" (click)="sendEmail()">
            <mat-icon>send</mat-icon> Enviar Correo
          </button>
        </div>

        <!-- Fila para Teléfono -->
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-input">
            <mat-label>Número de teléfono</mat-label>
            <input matInput placeholder="Sin 0 y sin 15" type="text" formControlName="Telefono">
            <mat-error *ngIf="personaForm.controls['Telefono'].hasError('required')">
              Este campo es <strong>requerido</strong>.
            </mat-error>
          </mat-form-field>

          <button mat-raised-button color="accent" class="form-button" [disabled]="!personaForm.valid" (click)="sendWhatsApp()">
            <mat-icon>send</mat-icon> Enviar WS
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <app-button-close></app-button-close>
</mat-dialog-actions>
